import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=3530dcdd&scoped=true&"
import script from "./Option.vue?vue&type=script&lang=js&"
export * from "./Option.vue?vue&type=script&lang=js&"
import style0 from "./Option.vue?vue&type=style&index=0&id=3530dcdd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530dcdd",
  null
  
)

export default component.exports